import { TrainerJumbotron, TrainerJumbotronType } from './trainer-jumbotron'
import { useTrainer } from '../../hook/use-trainers'
import { filterUtil } from '../../util/filter-util'
import { LoadingSpinner } from '../util/spinner/loading-spinner'
import { WorkoutList } from '../workout/workout-list'
import React, { useEffect, useMemo, useState } from 'react'
import { useWorkouts } from 'src/hook/use-workouts'

export const TrainerWorkoutList = (props: { trainerId: string }): React.ReactElement => {
  const { trainerId } = props
  const [showWorkouts, setShowWorkouts] = useState<boolean>(false)

  const { data: trainer } = useTrainer(trainerId)
  const filter = useMemo(() => ({ trainerIds: [trainerId] }), [trainerId])
  const { data: workouts = [] } = useWorkouts(filter)

  useEffect(() => {
    const isFiltered = filterUtil.isWorkoutFilterApplied(filter)
    setShowWorkouts(isFiltered)
  }, [trainerId, filter])

  return (
    <LoadingSpinner isLoading={!trainer}>
      {trainer && (
        <>
          <TrainerJumbotron trainer={trainer} type={TrainerJumbotronType.TRAINER_CLASSES} />
          <WorkoutList workouts={workouts} showWorkouts={showWorkouts} />
        </>
      )}
    </LoadingSpinner>
  )
}
